const footerObject = {
    configName: 'footer',
    wrapper: null,
    footer: null,
    heightFooter: null,
    status: -1,
    initialize: function () {
        if (this.status === 1) return;
        this.status = 1;
        this.wrapper = document.querySelector('.footer__wrapper');
        this.footer = this.wrapper.querySelector('.footer');
        this.reactToResize();
        main.setLoaderPercent(1);
    },
    reactToScroll: function (data) {
        let scroll = data.localOffset - window.innerHeight;
        if (scroll > 0) scroll = 0;

        if (data.isVisible) {
            this.wrapper.style.transform = 'translate3d(0,' + -scroll + 'px , 0)';
        } else {
            this.wrapper.style.transform = '';
        }
    },
    reactToResize: function () {
        this.wrapper.classList.add('_show');
        this.heightFooter = this.footer.getBoundingClientRect().height;
        this.wrapper.classList.remove('_show');
        this.wrapper.style.transform = '';
    }
};
